import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { buyPlan, plans, checkOffer } from "../../../Utils/Apis";

export const usePlans = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [selected, setSelected] = useState({});
  const [form, setForm] = useState({ status: false });

  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(plans, {});
    setData(data);
    setLoading(false);
  };
  const buy = async () => {
    setLoadingBtn(true);
    let newObj = {};
    if (form.status) {
      newObj = { off_code: selected.off_code };
    }
    const { data, status } = await post(
      buyPlan,
      { plan_id: selected.id, ...newObj },
      true
    );
    if (+status == "200") {
      window.location.replace(data.url);
    }
    setLoadingBtn(false);
  };
  const check = async init => {
    setLoadingCheck(true);
    const { data, status } = await post(
      checkOffer,
      { plan_id: selected.id, off_code: selected.off_code },
      true
    );
    setForm({ ...data, status: true });
    setLoadingCheck(false);
  };
  useEffect(() => {
    get();
  }, []);

  return {
    loadingCheck,
    check,
    data,
    loading,
    selected,
    setSelected,
    buy,
    loadingBtn,
    form,
    setForm,
  };
};
